<template>
  <BaseSelect
    v-model="modelValue"
    v-bind="$attrs"
    :options="options"
    :rules="$props.required ? 'required' : undefined"
    label="Account Type"
    size="sm"
  >
    <template v-slot:label>
      Account Type <span v-if="$props.required" class="text-danger">*</span>
    </template>

    <template v-slot:first>
      <b-form-select-option :value="undefined" :disabled="$props.required"
        >Select Account Type</b-form-select-option
      >
    </template>
  </BaseSelect>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'

import { BDX_ACCOUNT_TYPES, KEEP_AS_IS_OPTION } from '@constants'
import { BaseSelect } from '@components/base'

export default defineComponent({
  name: 'BDXEditFormAccountType',
  components: {
    BaseSelect
  },
  props: {
    value: String,
    required: Boolean,
    useKeepAsIsOption: Boolean,
    },
  emits: ['input'],
  setup(props, { emit }) {
    const modelValue = computed({
      get: () => props.value,
      set: (newValue) => emit('input', newValue)
    })
    let options = BDX_ACCOUNT_TYPES;
    if (props.useKeepAsIsOption) {
      options = [KEEP_AS_IS_OPTION, ...options];
    }


    return {
      options,
      modelValue
    }
  }
})
</script>
